<template>

  <div>

    <HistoryLogFieldDialog
        :pageId="pageId" :relation-key="relationKey" :history-log="historyLog" />

    <t-table
        @getPage="getPageHistoryLog()"
        :show="checkViewListTableDefault()"
        :filtered="filtered"
        :busy="!pageListIsLoaded"
        :user-auth="userAuth"
        :items="request.content"
        :fields="fields"
        :total-pages="request.totalPages"
        :total-elements="request.totalElements"
        title-items="Modificações"
        link-primary-column="createdDate"
        class="p-2"
        primary-key-column="historyLogId">

      <template #actions="{item}">

        <t-button text="Detalhes" @click="openHistoryLogDetail(item)" icon-list/>

      </template>

    </t-table>

  </div>


</template>
<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageFormMixin from "@/mixins/page/pageFormMixin"
import pageListMixin from "@/mixins/page/pageListMixin";
import {crudGeneral} from "@/services/resource/GeneralCRUD.service";
import HistoryLogFieldDialog from "@/views/modules/general/HistoryLogFieldDialog";


export default {
  mixins: [pageDefaultMixin, pageFormMixin, pageListMixin],
  components:{HistoryLogFieldDialog},
  name: 'HistoryLog',
  data() {
    return {
      filtered: false,
      pageHistoryLogNumber: 1, //declara aqui para não conflitar com pageNumber externo
      searchParamsHistory: new URLSearchParams(), //declara aqui para não conflitar
      path: "general/history-log", //Utilizar somente quando fora do padrão
      fields: [
        {key: "createdDate", label: "Data Modificado", cols: "3", formatter: "datetime"},
        {key: "createdUser", label: "Responsável", cols: "3"},
        {key: "version", label: "Versão", cols: "5"},
        {key: "qtyModifications", label: "Qtd. Modificações", cols: "2", align: "right"},
      ],
      //--------------------------------------------------------------------------------------
      historyLog:{},
      //--------------------------------------------------------------------------------------
    }
  },
  props: {
    pageId: {
      type: Number,
      required: true,
    },
    relationKey: {
      type: Number,
      required: true,
    },

  },

  methods: {

    mountedPrepare() {

      this.searchParamsHistory.append('pageId', this.pageId)
      this.searchParamsHistory.append('relationKey', this.relationKey)

    },

    async mountedContinued() {

      await this.getPageHistoryLog(1)

      this.pageListIsLoaded = true

    },


    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela
    async getPageHistoryLog(pageNumber, finishLoaded = true) {

      this.pageListIsLoaded = false

      //DEVERÁ MONTAR OS PARÂMETROS DINAMICAMENTE CONFORME OS CAMPOS FOREM MARCADOS COMO DE PESQUISA
      await crudGeneral.getAll(this.path, pageNumber, this.searchParamsHistory)
          .then(response => {

            this.request = response.data

            if (finishLoaded)
              this.pageListIsLoaded = true

          })
          .catch(error => {
            console.log('Erro externo: ' + error)
          })

    },
    openHistoryLogDetail(item) {
      this.historyLog = item
      this.openDialogForm('modal-history-log-detail')
    }
    //--------------------------------------------------------------------------------------
  },
  async mounted() {

    this.mountedPrepare()

    await this.getPageHistoryLog(this.pageHistoryLogNumber, false)

    await this.mountedContinued()

  },
}
</script>
